import React, { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";
import { useParams, useSearchParams } from "react-router-dom";
import { Navigate, Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import MILogo from "../../images/MI-Image.png";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { formatCurrency } from "../../utlis/utlis";
import Loading from "../../utlis/Loading";

// const socket = io(`${process.env.REACT_APP_API_WS_URL}`); // Node.js backend URL
const socket = io(`${process.env.REACT_APP_API_WS_URL}`, {
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  transports: ["websocket"],  // ⭐ Force WebSocket only
  upgrade: false,              // ⭐ Disable polling upgrade
});

const AYAPay = () => {
  const [searchParams] = useSearchParams();
  const paymentToken = searchParams.get("paymentToken");
  const { paymentMethod } = useParams();
  const [qrData, setQrData] = useState(null);
  const [status, setStatus] = useState(null);
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  const [isExpired, setIsExpired] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const qrRef = useRef();

  useEffect(() => {
    // Countdown logic
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setIsExpired(true); // Mark QR as expired
          return 0;
        }
        return prevTime - 1; // Decrease time
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup timer on unmount
  }, []);

  // Format time in MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${minutes}:${secs}`;
  };

  useEffect(() => {
    if (paymentToken) {
      // Register payment token with the server
      socket.emit("registerPaymentToken", paymentToken);
    }

    // Listen for Status updates from the server
    socket.on("paymentStatusUpdate", (data) => {
      if (data.paymentToken === paymentToken) {
        setStatus({
          code: data.statusCode,
          description: data.statusDescription,
        });

        navigate("/successPage", {
          state: {
            amount: data.amount,
            invoiceNumber: data.invoiceNo,
            currencyCode: data.currencyCode,
            serviceCharges: data.serviceCharges,
          },
        });
      }
    });

    // Handle reconnection events
    socket.on("connect", () => {
      if (paymentToken) {
        socket.emit("registerPaymentToken", paymentToken);
      }
    });

    return () => {
      if (paymentToken) {
        socket.off("paymentQRUpdate");
      }
      socket.off("connect");
    };
  }, [paymentToken, paymentMethod]);

  useEffect(() => {
    setLoading(true);
    // Send POST request to Spring Boot API
    const sendQR = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BACKEND_URL}/v1/ayapay/requestQr`,
          null, // No request body
          { params: { token: paymentToken } } // Query parameters
        );
        setQrData(response.data);
      } catch (error) {
        console.error(
          "Error sending QR:",
          error.response?.data || error.message
        );
      } finally {
        setLoading(false);
      }
    };

    sendQR();
  }, [paymentToken]); // Dependency array includes paymentToken

  if (status != null && status.code === "000") {
    return <h1>{status.description}</h1>;
  }

  // const saveQR = () => {
  //   const qrElement = qrRef.current;
  //   if (!qrElement) return;

  //   const svg = qrElement.querySelector("svg");
  //   if (svg) {
  //     const svgData = new XMLSerializer().serializeToString(svg);
  //     const canvas = document.createElement("canvas");
  //     const ctx = canvas.getContext("2d");

  //     const img = new Image();
  //     const svgBlob = new Blob([svgData], {
  //       type: "image/svg+xml;charset=utf-8",
  //     });
  //     const url = URL.createObjectURL(svgBlob);

  //     img.onload = () => {
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       // Draw white background
  //       ctx.fillStyle = "#FFFFFF"; // Set fill color to white
  //       ctx.fillRect(0, 0, canvas.width, canvas.height);

  //       // Draw the QR code on top of the white background
  //       ctx.drawImage(img, 0, 0);
  //       URL.revokeObjectURL(url);

  //       const pngUrl = canvas.toDataURL("image/png");
  //       const downloadLink = document.createElement("a");
  //       downloadLink.href = pngUrl;
  //       downloadLink.download = `AYAPay_QR_${paymentToken}.png`;

  //       // Handle mobile-specific case
  //       if (
  //         /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) &&
  //         !navigator.userAgent.includes("Windows")
  //       ) {
  //         // For mobile, show the image in a new tab (allowing users to long-press and save)
  //         window.open(pngUrl, "_blank");
  //       } else {
  //         // For desktop, trigger download
  //         document.body.appendChild(downloadLink);
  //         downloadLink.click();
  //         document.body.removeChild(downloadLink);
  //       }
  //     };

  //     img.src = url;
  //   }
  // };

  const handleBackToMerchantClick = async () => {
    setLoading(true);
    try {
      // Make an API call to the backend to get the URL and JSON response
      const response = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/payments/backtomerchant`,
        {
          params: {
            invoiceNo: qrData?.invoiceNo, // Send invoiceNo as a query parameter
          },
          headers: {
            Authorization: `Bearer `,
          },
        }
      );

      // Extract data from the response
      const {
        backtoMerchantUrl,
        merchantCode,
        invoiceNo,
        currency,
        amount,
        paymentChannel,
        paymentStatus,
        responseCode,
      } = response.data;

      // Create a form and append hidden input fields for each parameter
      const form = document.createElement("form");
      form.method = "POST";
      form.action = backtoMerchantUrl;

      const data = {
        merchantCode,
        invoiceNo,
        currency,
        amount,
        paymentChannel,
        paymentStatus,
        responseCode,
      };

      // Create hidden input fields for each piece of data
      Object.keys(data).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      });

      // Append the form to the body and submit it
      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Error redirecting to merchant:", error);
    } finally {
      setLoading(false);
    }
  };

  return loading ? (
    <Loading />
  ) : (
    <div className="container mt-5">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center">
        {/* Image and Title */}
        <div className="d-flex align-items-center">
          <img
            src={MILogo}
            alt="Logo"
            className="me-2"
            style={{
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      {/* Amount Section */}
      <div className="mt-3">
        {/* <div className="container"> */}
        <h5 className="text-primary m-0">Pay for Myanma Insurance</h5>

        {/* <h4>
            {qrData?.amount || 0} {qrData?.currencyCode}
          </h4> */}
        <div className="table-responsive">
          <table className="table" style={{ fontSize: "16px", width: "auto" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    width: "55%",
                    fontWeight: "bold",
                  }}
                  className="text-start"
                >
                  Total Amount :
                </td>
                <td className="text-end" style={{ fontWeight: "bold" }}>
                {(
                    Number(qrData?.amount) + Number(qrData?.serviceCharges) || 0
                  ).toLocaleString("en-US") + " MMK"}
                </td>
              </tr>
              <tr>
                <td style={{ width: "55%" }} className="text-start">
                  Transaction Amount :
                </td>
                <td className="text-end">
                  {formatCurrency(qrData?.amount)}
                </td>
              </tr>
              <tr>
                <td style={{ width: "55%" }} className="text-start">
                  Service Fee :
                </td>
                <td className="text-end">
                  {formatCurrency(qrData?.serviceCharges)}
                </td>
              </tr>
              <tr>
                <td style={{ width: "40%" }} className="text-start">
                  Invoice No. :
                </td>
                <td className="text-end">{qrData?.invoiceNo}</td>
              </tr>
            </tbody>
          </table>
          {/* </div> */}
        </div>
      </div>

      {/* QR Payment Section */}
      <div className="container mt-4">
        <h5>QR PAYMENT</h5>
        <p>AYAPay QR</p>
        <div className="text-danger d-flex justify-content-center align-items-center mt-3">
          {isExpired ? (
            <strong>QR is expired</strong>
          ) : (
            <>
              Please pay within 15 minutes. Time remaining:{" "}
              <strong>{formatTime(timeLeft)}</strong>
            </>
          )}
        </div>
        {!isExpired ? (
          paymentToken ? (
            <>
              {/* <h2>Payment Method: {paymentMethod}</h2> */}
              {qrData ? (
                <div
                  ref={qrRef}
                  className="d-flex justify-content-center align-items-center mt-3"
                  style={{
                    height: "200px",
                    width: "200px",
                    margin: "0 auto",
                  }}
                >
                  <QRCode value={qrData.qrData} size={256} />
                </div>
              ) : (
                // <p>Waiting for QR code...</p>
                <div
                  className="d-flex justify-content-center align-items-center mt-3"
                  style={{
                    height: "200px",
                    width: "200px",
                    margin: "0 auto",
                  }}
                >
                  <p>Waiting for QR code...</p>
                </div>
              )}
            </>
          ) : (
            <p>No payment information provided.</p>
          )
        ) : (
          <div className="text-center mt-3">
            <p className="text-danger">
              Your QR code has expired. Please request a new one.
            </p>
          </div>
        )}
      </div>

      {!isExpired ? (
        <>
          <div className="mt-4 text-center">
            <p>
              Please scan the QR code using a compatible{" "}
              <strong>AYAPay QR</strong> app to continue payment.
            </p>
            <p>Please take a screenshot of the QR</p>
          </div>
        </>
      ) : (
        <div className="text-center mt-3 mb-5">
          <button
            className="btn btn-primary"
            onClick={handleBackToMerchantClick}
          >
            Back To Merchant
          </button>
        </div>
      )}
    </div>
  );
};

export default AYAPay;
